/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { availabilitySchemeMemberSchema } from './availabilitySchemeMemberSchema';

export const pageResponseAvailabilitySchemeMemberSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(availabilitySchemeMemberSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
